/**
 * Get an object describing all amenities
 *
 * @return   {Object}  All amenities
 */
export const getAmenities = () => {
  return {
    espresso: {
      icon: 'coffee-24',
      label: 'Espresso',
    },
    'shared-printer': {
      icon: 'printer-24',
      label: 'Shared Printer',
    },
    'full-kitchen': {
      icon: 'kitchen-24',
      label: 'Full Kitchen',
    },
    wifi: {
      label: 'High-Speed Wifi',
      icon: 'wifi-24',
    },
    'phone-line-hookup': {
      label: 'Phone Line Hookup',
      icon: 'phone-24',
    },
    'free-parking': {
      label: 'Free Parking',
      icon: 'car-24',
    },
  };
};

/**
 * Groups space and room amenities by their type.
 *
 * @param   {Array} spaceAmenities  List of space amenities (each amenity should have a 'type' and 'slug').
 * @param   {Array} roomAmenities   List of room amenities (each amenity should have a 'type' and 'slug').
 * @return  {Object}                An object containing:
 *   - other: Array of amenities that are not of type 'mood' or 'transit'.
 *   - moods: Array of amenities with type 'mood'.
 *   - transit: Array of amenities with type 'transit'.
 *   - allAmenitiesBySlug: Object mapping space amenity slugs to their amenity objects.
 *   - allRoomAmenitiesBySlug: Object mapping room amenity slugs to their amenity objects.
 */
export function groupAmenitiesByType(spaceAmenities, roomAmenities) {
  let moods = [];
  let transit = [];
  let other = [];
  let allAmenitiesBySlug = {};
  let allRoomAmenitiesBySlug = {};

  for (let amenity of roomAmenities) {
    // Add to list of all amenities
    allRoomAmenitiesBySlug[amenity.slug] = amenity;

    // 'other' is used to represent the space and room amenities that are not moods or transit
    if (amenity.type !== 'mood' && amenity.type !== 'transit') {
      other.push(amenity);
    }
  }

  for (let amenity of spaceAmenities) {
    // Add to list of all amenities
    allAmenitiesBySlug[amenity.slug] = amenity;

    // Then sort by mood or other
    if (amenity.type === 'mood') {
      moods.push(amenity);
    } else if (amenity.type === 'transit') {
      transit.push(amenity);
    } else {
      other.push(amenity);
    }
  }

  return {
    other,
    moods,
    transit,
    allAmenitiesBySlug,
    allRoomAmenitiesBySlug,
  };
}
